export default __webpack_public_path__ + "static/media/5.d0757595.png";